export enum AreaUnitEnum {
  SQFT = 'Sqft',
  SQM = 'Ssqm',
  ACRE = 'Acre',
}
